import { render, staticRenderFns } from "./CasePrizePrivate.vue?vue&type=template&id=53323552&"
import script from "./CasePrizePrivate.vue?vue&type=script&lang=js&"
export * from "./CasePrizePrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports